// @flow

import React, { Component } from 'react';
import { connect }          from 'react-redux';
import { getTranslate }     from 'react-localize-redux';
import documentHelper       from 'helpers/document.helper';
import $                    from 'jquery';
import Calculator           from './calculator';
import Application          from './application';
import { setActiveApplication }           from 'actions/applications/applications'
import storageHelper, { KEY_CURRENT_APP } from 'helpers/storage.helper';
import './index.css';

class InsuranceInquiry extends Component {

  _eleMagicLine = null;
  _activeTabRef = null;
  _eleSubNav    = null;
  tabActiveEle  = null;

  state = {
    magicLineStyle: {}
  }

  constructor() {
    super();

    this._handleMagicLine = this._handleMagicLine.bind(this);
    this._setActiveTab    = this._setActiveTab.bind(this);
    this._setApplication  = this._setApplication.bind(this);
  }

  componentDidMount = () => {
    const { currentApp } = this.props;

    const eleMagicLine = this._eleMagicLine;

    this._handleMagicLine();

    $(document).find('.sub-nav a').on('shown.bs.tab', function (e) {
      var currentEle = $(e.target); // Newly active element
      var leftPos  = currentEle.position().left;
      var newWidth = currentEle.offsetWidth || currentEle[0].offsetWidth;

      $(eleMagicLine).stop().animate({
        'left': leftPos,
        'width': newWidth
      });
    });

    // Set default document title
    documentHelper.setTitle(this.props.translate('insuranceinquiry.tabs.overview'));

    // Add resize event listener
    window.addEventListener("resize", this._windowIsResized);

    // Set default application
    let currentAppLS = storageHelper.getItem(KEY_CURRENT_APP);
    if( currentAppLS ) {
      this._setApplication(null, String(currentAppLS));
    } else {
      if( !currentApp ) {
        this._setApplication(null, '0');
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this._windowIsResized);
  }

  _windowIsResized = (e: any) => {
    this._handleMagicLine(this.tabActiveEle);
  }

  _setActiveTab = (e: any) => {
    this.tabActiveEle = e.target;
    const { dataset: { documentTitle } } = e.target;
    // Documet title
    documentHelper.setTitle(documentTitle);
  }

  _handleMagicLine = (activeEle) => {
    let activeTab = activeEle || this._activeTabRef;
    if( activeTab ) {
      this.setState({ magicLineStyle: {
          width: activeTab.offsetWidth + 'px',
          left: activeTab.offsetLeft + 'px',
        },
      });
    }

    return false;
  }

  _setApplication = (item: any, order_id: string = '0') => {
    const { apps: { loading, rows }, dispatch } = this.props;
    let current;

    if( !loading ) {
      // If there is no data in localstorage and redux,
      // select first application as default one
      if( !item && !order_id ) {
        current = rows[0];
      } else {
        // Set current app
        if( !item && order_id ) {
          current = rows.find(obj => String(obj.order_id) === String(order_id));
        } else {
          current = rows.find(obj => String(obj.order_id) === String(item.order_id));
        }
        if (!current && rows.length) {
          const filtered_apps = rows.filter(item => item.validation_message.value === 'Application is OK');
          const sorted_aplications = filtered_apps.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
          current = sorted_aplications.length ? sorted_aplications[0] : rows[0]
        }
      }

      if( current ) {
        dispatch(setActiveApplication(current));
        storageHelper.setItem(KEY_CURRENT_APP, current.order_id);
      }
    }
  }

  render() {
    const { translate, history } = this.props;
    const { magicLineStyle } = this.state;

    return (
      <div className="insurance-inquiry">
        <nav className="sub-nav" ref={(ref) => { this._eleSubNav = ref; }}>
          <ul>
            <li className="active">
              <a ref={(ref) => { this._activeTabRef = ref; }} href="#tab-ii1" data-toggle="tab" onClick={this._setActiveTab} data-document-title={translate('insuranceinquiry.tabs.overview')}>
                {translate('insuranceinquiry.tabs.application')}
              </a>
            </li>
            <li><a href="#tab-ii2" data-toggle="tab" onClick={this._setActiveTab} data-document-title={translate('calculator.title')}>{translate('insuranceinquiry.tabs.calculator')}</a></li>
          </ul>
          <span className='magic-line' style={magicLineStyle} ref={(ref) => { this._eleMagicLine = ref; }}></span>
        </nav>
        <div className="tab-content">
          <div className="tab-pane fade active in" id="tab-ii1">
            <div className="application"><Application history={history} _callbackSetApplication={this._setApplication} /></div>
          </div>
          <div className="tab-pane fade" id="tab-ii2">
            <div className="calculator"><Calculator _callbackSetApplication={this._setApplication} /></div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  translate: getTranslate(state.locale),
  apps     : state.application.applications
});

export default connect(mapStateToProps)(InsuranceInquiry);



// WEBPACK FOOTER //
// ./src/components/main/InsuranceInquiry/index.js